var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Icon Calendar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11217",
    d: "M5 13h3v3h2v-3h3v-2h-3V8H8v3H5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11218",
    d: "M16 2h-2V0h-2v2H6V0H4v2H2a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V4a2 2 0 00-2-2zm0 16H2V6h14z"
  })));
}
export default SvgCalendar;